import { FC, CSSProperties } from 'react';
import confirmModalClass from '../../assets/scss/ConfirmModal/ConfirmModal.module.scss';
import { ConfirmTitle } from './ConfirmTitle';

export const ConfirmTitleWithBorder: FC<{
  title: string;
  style?: CSSProperties;
  border?: boolean;
}> = ({ title, style, border = true }) => {
  return (
    <>
      <ConfirmTitle
        title={title}
        style={style}
      />
      {border && <div className={confirmModalClass.border}></div>}
    </>
  );
};
